<div class="content-dashboard">
    <div class="content-block-dashboard" *ngIf="isDashboard ; else elseBlock">
        <ww-dashboard [dashbordCongiguration]="ubtDashboardConfig">
        </ww-dashboard>
    </div>
    <ng-template #elseBlock>
        <h2 fxLayout="row" fxLayoutAlign="center end"> {{title}} </h2>
    </ng-template>
</div>